import ErrorHandler from './error.handler';

export default ErrorHandler;
